import { STATUS_LOAN } from "#colaborador/Solicitudes/constants"
import ButtonIcon from "#common/buttons/ButtonIcon"
import CircularSkeleton from "#common/skeleton/CircularSkeleton"
import PERMISOS from "#constants/perfiles"
import { DialogMaster } from "#core/components/dialog/Dialog"
import InputNumber from "#core/components/input/number/InputNumber"
import ErrorResponse from "#core/pages/ErrorResponse"
import { useApi } from "#hooks/useApi"
import { useApiSend } from "#hooks/useApiSend"
import { UseHasPermission } from "#hooks/useHasPermission"
import CheckCircleIcon from "@mui/icons-material/CheckCircle"
import { Box, TextField } from "@mui/material"
import FormControlLabel from "@mui/material/FormControlLabel"
import FormGroup from "@mui/material/FormGroup"
import Switch from "@mui/material/Switch"
import { loanIdGet, loanIdPut } from "#loan/services/api"
import { Fragment, useCallback, useEffect, useMemo, useState } from "react"

export default function LoanStatusPay({ id, autoFetch = true, setValue, value }) {
	const params = useMemo(() => ({ id: id, params: { bank: "" } }), [id])
	const { data, loading, error } = useApi(loanIdGet, { autoFetch, params })

	useEffect(() => {
		if (data) {
			const edit_bank = !data.banco
			setValue({ edit_bank, ...data } || { edit_bank })
		}
	}, [data, setValue])

	if (loading) return <CircularSkeleton />
	if (error) return <ErrorResponse api={error} />

	return (
		<Box sx={{ display: "grid", gap: 2 }}>
			<TextField
				label="Banco"
				value={value.banco}
				onChange={(event) => {
					setValue({ ...value, banco: event.target.value })
				}}
				fullWidth
				disabled={!value?.edit_bank}
			/>
			<InputNumber
				label="Numero de cuenta"
				value={value?.cuenta}
				setValue={(cuenta) => setValue({ ...value, cuenta })}
				disabled={!value?.edit_bank}
			/>
			<InputNumber
				label="Clabe interbancaria "
				value={value?.clabe}
				setValue={(clabe) => setValue({ ...value, clabe })}
				disabled={!value?.edit_bank}
			/>
			{data.banco && (
				<FormGroup aria-label="position" row sx={{ justifyContent: "center" }}>
					<FormControlLabel
						control={
							<Switch
								color="primary"
								checked={value?.edit_bank}
								onChange={(event) => {
									setValue({ ...value, edit_bank: event.target.checked })
								}}
							/>
						}
						label="Editar datos bancarios"
						labelPlacement="top"
					/>
				</FormGroup>
			)}
			{/* <InputNumber
				label="Interés del préstamo % "
				value={value?.interest}
				endIcon
				setValue={(interest) => setValue({ ...value, interest })}
			/>

			<InputDate
				label="Fecha de pago"
				value={value?.day_payment}
				onChange={(date) => setValue({ ...value, day_payment: date })}
				fullWidth
			/> */}
		</Box>
	)
}

export const LoanStatusPayDialog = ({ id, loan, reload }) => {
	const [data, setData] = useState({})
	const [open, setOpen] = useState(false)
	const [disabled, setDisabled] = useState(false)

	const success = () => {
		reload()
		setOpen(false)
	}
	const end = () => {
		setDisabled(false)
	}
	const { fetch } = useApiSend(loanIdPut, { success, end })

	const handleSubmit = useCallback(() => {
		setDisabled(true)
		fetch(id, {
			status: STATUS_LOAN.PAY,
			...data,
		})
	}, [data, fetch, id])
	const isRh = UseHasPermission(PERMISOS.RH)

	if (!isRh) return null
	if (loan?.status !== STATUS_LOAN.PASS_PAY) return null

	return (
		<Fragment>
			<ButtonIcon
				icon={<CheckCircleIcon />}
				onClick={() => setOpen(true)}
				color="success"
				title="pasar a pagos"
			/>

			<DialogMaster
				{...{
					open,
					setOpen,
					title: "Datos Bancarios",
					handleSubmit: handleSubmit,
					maxWidth: "sm",
					disabled,
				}}
			>
				<LoanStatusPay id={id} value={data} setValue={setData} autoFetch={open} />
			</DialogMaster>
		</Fragment>
	)
}
